// Spanish translations (Español)
import { TranslationKeys } from './en';

export const es: TranslationKeys = {
  // Common
  common: {
    home: 'Inicio',
    settings: 'Configuración',
    language: 'Idioma',
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Configuración',
    home: 'Inicio',
    howToPlay: 'Cómo Jugar',
    pieceRules: 'Reglas de Piezas',
    language: 'Idioma',
    manageSubscription: 'Gestionar Suscripción',
    gameHistory: 'Historial de Juegos',
    analytics: 'Análisis',
    premiumAccount: 'Cuenta Premium',
    chatEnabled: 'Chat: Activado',
    chatDisabled: 'Chat: Desactivado',
  },

  // Piece Rules
  pieceRules: {
    title: 'Reglas de Piezas',
    description: 'Aprender movimiento de piezas',
    selectPiece: 'Seleccionar Pieza',
    selectedLabel: 'Seleccionado:',
    statusLabel: 'Estado:',
    statusReady: 'Listo',
    statusViewing: 'Viendo',
    movement: 'Movimiento',
    regularMovement: 'Movimiento Regular',
    ability: 'Habilidad',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Movimiento',
    savage: 'Salvaje',
    birdtype: 'Tipo Pájaro',
    birdType: 'Tipo Pájaro',
    wallBlock: 'Bloqueo de Muro',
    moveblocks: 'Bloques de Movimiento',
    wallclimb: 'Escalar Muro',
    lilypad: 'Nenúfar',
    poisonous: 'Venenoso',
    meadow: 'Pradera',
    parasiticfungi: 'Hongo Parásito',
    zombification: 'Zombificación',
    fungi: 'Hongo',
    traverse: 'Atravesar',
    capture: 'Capturar',
    faint: 'Desmayo',
    leap: 'Salto',
    swing: 'Balanceo',
    consume: 'Consumir',
    gamble: 'Apostar',
    entangle: 'Enredar',
    ink: 'Tinta',
    rotate: 'Rotar',
    backstep: 'Paso Atrás',
    trample: 'Pisotear',
    charge: 'Carga',
    lane: 'Carril',
    snakestrike: 'Golpe de Serpiente',
    shedskin: 'Mudar Piel',
    house: 'Refugio',
    plant: 'Tipo Planta',
    planttype: 'Tipo Planta',
    capturehost: 'Capturar Huésped',
    contagion: 'Contagio',
    lonewolf: 'Lobo Solitario',
    hop: 'Saltar',
    decay: 'Decaer',
    slide: 'Deslizar',
    block: 'Bloquear',
    poison: 'Veneno',
    infection: 'Infección',
    howl: 'Aullido',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'El Oso puede moverse una casilla en cualquier dirección, como un rey en ajedrez',
    bearMovementPost: 'Solo es bloqueado por piezas aliadas (excepto Árboles, ¡los Osos pueden trepar Árboles!)',
    bearSavage: 'Un Oso puede superar habilidades defensivas como el Bloqueo de Rinoceronte',
    bearSavagePost: 'Usando Salvaje, el Oso puede capturar cualquier pieza desde cualquier dirección, añadiendo letalidad',
    // Crane
    craneMovement: 'La Grulla puede moverse 1 o 2 casillas en cualquier línea recta',
    craneMovementPost: '¡La Grulla incluso puede volar sobre otras piezas!',
    craneBirdType: 'Las piezas tipo pájaro no pueden capturar piezas grandes o depredadoras',
    craneBirdTypePost: 'Esto incluye Árbol, Rinoceronte, Oso y Lobo',
    // Frog
    frogMovement: 'La Rana salta 2 casillas en diagonal',
    frogMovementPost: 'No puede saltar solo una',
    frogWallBlock: 'Si el camino regular de 2 casillas de la Rana está bloqueado por una pared u otra pieza que no puede capturar',
    frogWallBlockPost: 'Su movimiento regular se acorta a 1 casilla en diagonal',
    frogWallClimb: 'Cuando la Rana está en el borde del tablero (Columna A o E) puede moverse hacia arriba o abajo una casilla',
    frogWallClimbPost: 'A menos que esté bloqueada por una pieza aliada o un Rinoceronte frente a la Rana',
    frogLilypad: 'Si la Rana aún no se ha movido en un juego, puede moverse a cualquiera de las primeras 3 filas como una poderosa habilidad defensiva',
    frogLilypadPost: 'Puede capturar cualquier pieza regular usando Salto de Nenúfar, excepto un Rinoceronte en una fila más alta',
    frogPoisonous: '¡Cuando cualquier animal captura una pieza de Rana, te envenenas!',
    frogPoisonousPost: 'Una pieza envenenada salta su próximo turno disponible antes de recuperarse',
    // Fungi
    fungiMovement: 'El Hongo puede moverse una casilla en cualquier dirección',
    fungiMovementPost: 'Solo es bloqueado por piezas aliadas',
    fungiMeadow: 'El Hongo reduce la capacidad de movimiento de la pieza de Árbol enemiga',
    fungiMeadowPost: 'La pieza de Árbol enemiga no puede moverse a 1 casilla del Hongo',
    fungiParasitic: 'El Hongo puede inmovilizar la pieza de Árbol enemiga',
    fungiParasiticPost: 'Si el Hongo está a 1 casilla del Árbol enemigo, no puede moverse hasta que el Hongo se aleje o sea capturado',
    fungiZombification: 'El Hongo puede zombificar cualquier pieza animal enemiga que lo capture, permitiendo controlar el animal enemigo durante un turno',
    fungiZombificationPost: 'La pieza zombificada también se considera la pieza de Hongo para ese turno, incluso si el Hongo era tu rey, el juego no termina hasta después de ese turno',
    fungiFungi: 'Hongo',
    fungiFungiPost: '¡Como veneno, enredo e infección de virus, pero no zombificación ya que puede zombificar a otros!',
    // Goat
    goatMovement: 'La Cabra puede moverse una casilla en cualquier dirección',
    goatMovementPost: 'La Cabra se mueve lentamente pero tiene habilidades poderosas',
    goatTraverse: 'La Cabra puede atravesar cualquier otra pieza conectada para crear un potencial de movimiento masivo',
    goatTraversePost: 'La Cabra no puede atravesar Cabras Desmayadas o piezas pequeñas como el Virus',
    goatCapture: 'La Cabra no puede capturar ningún Depredador',
    goatCapturePost: 'Como el Oso o el Lobo',
    goatFaint: 'La Cabra puede desmayarse para evitar la captura excepto de piezas grandes como el Árbol y el Rinoceronte',
    goatFaintPost: 'Mientras está desmayada, los oponentes pueden "pararse" sobre la cabra desmayada para detener su movimiento',
    // Monkey
    monkeyMovement: 'El Mono puede moverse una casilla en cualquier dirección',
    monkeyMovementPost: 'Sin otras piezas para utilizar, el Mono tiene movimiento limitado',
    monkeyLeap: 'El Mono, como un juego de damas, puede saltar sobre otras piezas en línea recta para un enorme potencial de movimiento',
    monkeyLeapPost: 'Pero si salta sobre una pieza enemiga, el Mono debe tirar un dado para sobrevivir al salto, ¡1/6 de probabilidad de captura por cada enemigo que salte!',
    monkeySwing: 'Si un Mono usa un salto sobre un Árbol, el Mono gana un turno extra',
    monkeySwingPost: 'Usar el columpio del Árbol crea una poderosa combinación sinérgica entre el Mono y la pieza de Árbol',
    monkeyConsume: 'El Mono puede consumir una pieza de Hongo para un turno extra',
    monkeyConsumePost: 'Lo que lleva a combinaciones devastadoras cuando se combina con otros turnos extra',
    monkeyGamble: 'Además de tirar un dado para saltar sobre enemigos, el Mono debe apostar para capturar al Oso',
    monkeyGamblePost: 'El mono debe sacar un 5 o un 6 en un dado de 6 caras para capturar al Oso o es capturado él mismo',
    // Octopus
    octopusMovement: 'El Pulpo se mueve una casilla en cualquier dirección',
    octopusCapture: 'El Pulpo solo puede capturar ortogonalmente',
    octopusCapturePost: '¡El pulpo puede capturar o enredar piezas de formas complejas, así que siempre verifica las capturas rojas y los enredos morados!',
    octopusEntangle: '¡El Pulpo puede enredar piezas enemigas adyacentes, inmovilizándolas, incluso puede moverse una casilla y enredar enemigos!',
    octopusEntanglePost: 'Las piezas enredadas no pueden moverse hasta que el Pulpo se aleje o sea capturado',
    octopusInk: 'El Pulpo puede usar tinta para escapar de situaciones peligrosas, creando hasta 3 sombras',
    octopusInkPost: 'Confundiendo al enemigo y permitiendo jugadas de cebo y evasión interesantes',
    // Penguin
    penguinMovement: 'El Pingüino se desliza en línea recta en su dirección establecida hasta que una pared o pieza bloquee su movimiento',
    penguinMovementPost: 'Después de moverse, el Pingüino dentro del mismo turno también puede establecer su dirección final',
    penguinRotate: 'Al comienzo del partido, un Pingüino está mirando hacia abajo y debe rotar antes de poder deslizarse, también conocido como dormir',
    penguinRotatePost: 'El pingüino en cualquier posición puede elegir rotar en lugar de moverse',
    penguinBirdType: 'El Pingüino tiene capacidades de captura limitadas, como la Grulla, no puede capturar piezas grandes o depredadoras como el Árbol, Rinoceronte, Oso o Lobo',
    penguinBirdTypePost: 'Después de capturar, el Pingüino puede rotar para mirar en cualquier dirección para posicionamiento estratégico',
    // Rhino
    rhinoMovement: 'El Rinoceronte se mueve dos casillas hacia adelante solamente',
    rhinoMovementPost: 'No puede moverse solo 1 casilla',
    rhinoBackStep: 'El Rinoceronte puede moverse hacia atrás-izquierda o atrás-derecha',
    rhinoCharge: 'El Rinoceronte una vez por juego puede viajar una casilla extra hacia adelante usando su habilidad de carga',
    rhinoChargePost: 'Lo que lleva a un potencial devastador de movimiento y captura',
    rhinoTrample: 'El Rinoceronte captura todas las piezas en su camino de viaje con Pisotón',
    rhinoTramplePost: 'Incluida una pieza de Cabra desmayada',
    rhinoLane: 'El Rinoceronte puede intercambiar lugares con otra pieza aliada permitiendo juego de carril estratégico',
    rhinoLanePost: 'Pero solo si el Rinoceronte y la pieza Aliada no se han movido',
    // Snake
    snakeMovement: 'La Serpiente puede moverse 2 casillas en cualquier línea recta',
    snakeMovementPost: 'La Serpiente se mueve exactamente 2 casillas a menos que esté bloqueada por una pared o pieza aliada',
    snakeMoveBlocks: 'Cuando está bloqueada por una pared o pieza que no puede capturar, el movimiento de la Serpiente se acorta a 1 casilla',
    snakeMoveBlocksPost: 'Aún puede moverse dos casillas incluso si hay una pieza intermedia',
    snakeStrike: 'La Serpiente puede golpear 3 casillas hacia adelante si hay un animal enemigo',
    snakeStrikePost: 'Siempre que ninguna pieza intermedia bloquee su camino',
    snakeShedskin: 'Una vez por juego, la Serpiente puede mudar su piel y volver a la primera fila si la casilla está libre',
    snakeShedskinPost: 'Este renacimiento le da a la Serpiente una vida extra cada juego',
    // Tree
    treeMovement: 'El Árbol puede moverse una casilla hacia adelante o a cualquier casilla en su fila de lado a lado',
    treeMovementPost: 'Siempre que su camino no esté bloqueado',
    treeHouse: 'El Árbol puede albergar otras piezas, protegiéndolas de enemigos que no pueden trepar Árboles. Muchas piezas pueden trepar como el Oso, Grulla, Rana, Hongo, Cabra, Mono, Pulpo y Serpiente',
    treeHousePost: 'Cuando una pieza que puede trepar un árbol ataca, solo captura la pieza albergada, protegiendo al Árbol',
    treeTrample: 'El Árbol, como el Rinoceronte, captura todas las piezas en una casilla cuando se mueve',
    treeTramplePost: 'Esto incluye una Cabra desmayada',
    treePlant: 'El Árbol es una planta, no un animal, por lo que es inmune a varios efectos',
    treePlantPost: '¡Como veneno, zombificación, enredo e infección de virus!',
    // Virus
    virusMovement: 'El Virus solo puede moverse a casillas ocupadas con animales, que están a dos casillas de distancia',
    virusMoveBlocks: 'El Virus puede moverse solo una casilla si está al lado de una pared',
    virusCaptureHost: 'Cuando el Virus aterriza en (dentro de) cualquier pieza animal, solo los infecta, pueden continuar el juego regular mientras están infectados',
    virusCaptureHostPost: 'El Virus solo captura la pieza cuando sale del huésped infectado',
    virusContagion: 'El Virus puede propagarse rápidamente infectando múltiples huéspedes en un solo turno',
    virusContagionPost: 'El contagio permite al Virus hacer tantos movimientos legales como quiera cada turno',
    // Wolf
    wolfMovement: 'El Lobo puede moverse en forma de L, como el caballo en ajedrez',
    wolfMovementPost: 'No está obstruido por ninguna otra pieza',
    wolfLoneWolf: 'Lobo',
    wolfLoneWolfPost: 'El Lobo también se considera solitario cuando todavía tiene una Cabra desmayada o un aliado virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Arrastra para explorar • Pellizca para zoom',
    dragToExploreDesktop: '🖱️ Arrastra para explorar • Desplaza para zoom',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Atrás',
    next: 'Siguiente',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'SANDBOX',
    description: 'Experimentar y Practicar',
    mode: 'Modo:',
    modeValue: 'Sandbox',
    status: 'Estado:',
    statusReady: 'Listo',
    clearBoard: 'Limpiar Tablero',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIJUGADOR',
    description: '¡Encuentra tu partida y compite!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',
    placementMatches: 'Partidas de Clasificación',
    matchProgress: 'Progreso de Partidas',
    gamesCompleted: '{games} / 10 Partidas Completadas',
    estimatedFinalRating: 'Clasificación Final Estimada',
    startingRating: 'Clasificación inicial',
    matchesRemaining: '{matches} partidas restantes',
    findPlacementMatch: 'Buscar Partida de Clasificación',
    findMatch: 'Buscar Partida',
    competitive: 'Competitivo',
    competitiveDesc: 'Encuentra oponentes cercanos a tu clasificación',
    quick: 'Rápido',
    quickDesc: 'Encuentra partidas competitivas rápidamente',
    casual: 'Casual',
    casualDesc: 'Sin clasificación - ¡juega por diversión!',
    placement: 'Clasificación',
    placementDesc: 'Completa 10 partidas para obtener rango',
    startSearch: 'Iniciar Búsqueda',
    searching: 'Buscando...',
    mode: 'Modo:',
    inQueue: 'En Cola:',
    players: 'jugador',
    playersPlural: 'jugadores',
    cancelSearch: 'Cancelar Búsqueda',
    status: 'Estado:',
    ready: 'Listo',
    selectingKing: 'Seleccionando Rey',
    placingPieces: 'Colocando Piezas',
    playing: 'Jugando',
    gameType: 'Tipo de Juego:',
    opponent: 'Oponente:',
    opponentElo: 'ELO del Oponente:',
    unranked: 'Sin clasificar',
    dragPieces: 'Arrastra las piezas al tablero',
    lightPieces: 'Piezas Claras (Tú)',
    darkPieces: 'Piezas Oscuras (Tú)',
    waitingForOpponent: 'Esperando al oponente...',
    waitingForKing: 'Esperando a que el oponente seleccione su rey...',
    invalidPlacement: 'Colocación Inválida',
    lightTurn: '¡Es el turno del jugador Claro!',
    darkTurn: '¡Es el turno del jugador Oscuro!',
    onlyLightPieces: '¡Solo puedes colocar piezas claras!',
    onlyDarkPieces: '¡Solo puedes colocar piezas oscuras!',
    mustPlaceOnRow: '¡Las piezas {color} deben colocarse en la fila {row}!',
    chat: 'Chat',
    typeMessage: 'Escribe un mensaje...',
    send: 'Enviar',
  },

  // Main Page
  mainPage: {
    title: 'AJEDREZ ANIMAL',
    subtitle: 'Un juego para humanos',
    playersOnline: 'Jugadores en línea actuales',
    placement: 'Clasificación',
    placementProgress: 'Clasificación',
    challengeAI: 'Desafiar IA',
    multiplayer: 'Multijugador',
    sandbox: 'Modo Libre',
    tutorials: 'Tutoriales',
    shop: 'Tienda',
    collection: 'Colección',
    history: 'Historial',
    analytics: 'Análisis',
    courses: 'Cursos',
    upgradeAccount: 'Mejorar cuenta',
    signIn: 'Iniciar Sesión',
    playAsGuest: 'Jugar como Invitado',
    welcomeBack: '¡Bienvenido de nuevo! Normalmente juegas como',
    privacyPolicy: 'Privacy Policy',

    // Learn the Pieces section
    learnThePieces: 'Aprende las piezas',

    // Learn the Rules section
    learnTheRules: 'Aprende las Reglas',
    premiseTitle: 'Premisa',
    premiseText: 'Zodiac es una alternativa al ajedrez con un REY OCULTO de una lista de 13 piezas, selecciona una lista única y luego engaña a tu oponente para derrotarlo en un tablero de 5 por 8',
    selectionTitle: 'Selección',
    selectionText: 'Para comenzar un juego, elige secretamente tu rey, luego coloca tus 5 piezas alternadamente con tu oponente para crear uno de más de 500 mil millones de estados iniciales.',
    objectiveTitle: 'Objetivo',
    objectiveText: '¡Lee a tu oponente para CAPTURAR su rey secreto o CORRE con tu rey a través del tablero para asegurar la victoria!',
    competeTitle: 'Compite',
    competeText: '¡Pon a prueba tus habilidades en la escalera, desarrolla nuevas técnicas y estrategias personales, sube de rango para enfrentarte a los mejores!',
    fullRulesButton: 'Haz clic aquí para ver las reglas oficiales completas',

    // FAQ section
    faqTitle: 'Preguntas Frecuentes',
    faqQuestion1: '¿Cuál es la idea detrás del ajedrez Zodiac?',
    faqAnswer1: 'El ajedrez Zodiac se inspiró inicialmente en las palabras de Bobby Fischer sobre su inspiración para hacer Chess960, queríamos expandir la idea de combatir la memorización mecánica y celebrar la intuición humana en profundidad insondable!',
    faqQuestion2: '¿Por qué necesitamos una alternativa al ajedrez?',
    faqAnswer2: '¡No la necesitamos! ¡Zodiac no quiere alejar a la gente de jugar ajedrez! Es una opción diferente con sus propias fortalezas y debilidades, esperamos que te diviertas con ella y nos ayudes a adaptar este juego para dar vida a jugadas novedosas',
    faqQuestion3: '¿Cómo se gana en Zodiac Chess?',
    faqAnswer3: 'Hay tres formas de ganar: capturar la pieza del rey oculto de tu oponente, correr tu propio rey al lado opuesto del tablero, o en una partida con controles de tiempo, que se acabe el tiempo de tu oponente',
    faqQuestion4: '¿Es esto un FAQ?',
    faqAnswer4: 'Sí, puedes ver cualquiera de las preguntas listadas en el FAQ y si quieres más detalles, puedes hacer clic en las preguntas y luego leer los siguientes detalles, como estos detalles que estás leyendo ahora',
    faqQuestion5: '¿Cuánto dura un juego típico?',
    faqAnswer5: '¡Cada juego difiere ampliamente! Algunos juegos terminan en 2 movimientos y algunos pueden tardar 30 minutos, generalmente tendemos a encontrar que están en la marca de 5-15 minutos!',
    faqQuestion6: '¿Qué pasa si nadie puede hacer un movimiento legal?',
    faqAnswer6: 'Si un jugador no puede hacer ningún movimiento legal (tablas), el juego termina en empate. ¡El juego también puede terminar en empate por repetición (mismo estado del tablero 3 veces) o por acuerdo mutuo entre los jugadores!',

    // About section
    aboutButton: 'Acerca de',
    developerInterface: 'Interfaz de Desarrollador',
  },

  // About Modal
  about: {
    title: 'Acerca de Zodiac',
    paragraph1: 'Zodiac es un juego de tablero similar al ajedrez que combina elementos de selección de piezas de juegos como LoL y DotA, con mecánicas de farol del póker o juegos de deducción social.',
    paragraph2: 'Las primeras versiones del juego se crearon en 2014, con el nombre Shadow Chess. En 2018 fue rediseñado para ser lo que ves hoy, involucrando un elenco de piezas divertidas con patrones de movimiento y habilidades equilibrados pero únicos.',
    paragraph3: 'Nuestra visión es registrar todos los datos de juego del usuario para continuar evolucionando el juego en un esfuerzo por mantener el juego fresco, alentando jugadas novedosas.',
    paragraph4: '¡Con el espacio de búsqueda gigante de Zodiac, información oculta y posiciones de tablero iniciales, esperamos evitar el dominio de la IA y mantener zodiac como un juego para humanos!',
  },

  // Privacy Policy (TODO: Translate to Spanish)
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated',
    introduction: { title: 'Introduction', p1: 'Welcome to Zodiac Chess ("we," "our," or "us"). We are committed to protecting your privacy and ensuring you have a safe and enjoyable gaming experience. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and game.', p2: 'By using Zodiac Chess, you agree to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our service.', contact: 'Contact us at:' },
    infoCollect: { title: 'Information We Collect', accountInfo: { title: '1. Account Information', item1: 'Email Address: Required for account creation and communication', item2: 'Username: Your chosen display name', item3: 'Password: Encrypted and securely stored' }, gameData: { title: '2. Game Data', item1: 'Game Statistics: Wins, losses, ELO rating, placement match progress', item2: 'Gameplay Data: Piece selections, moves made, strategies used', item3: 'Match History: Records of games played, opponents faced', item4: 'In-Game Purchases: Cosmetic items and premium membership status' }, technicalData: { title: '3. Technical Data', item1: 'Device Information: Browser type, operating system', item2: 'Usage Data: Pages visited, time spent, features used', item3: 'Local Storage: Language preferences, UI settings, temporary game state' } },
    children: { title: 'Children\'s Privacy (COPPA Compliance)', p1: 'Zodiac Chess is designed to be family-friendly and suitable for players of all ages, including children. We take special care to comply with the Children\'s Online Privacy Protection Act (COPPA).', p2: 'For users under 13 years of age: We recommend that children use our guest play mode, which does not require account creation or data collection. Guest accounts do not have access to text chat features, ensuring children are not exposed to communication with the wider internet. If a child creates an account, we require parental consent before collecting any personal information.', p3: 'We do NOT knowingly collect, use, or share personal information from children under 13 without verified parental consent.', p4: 'Chat Safety: Text chat is automatically disabled for all guest/temporary accounts. Standard account holders have the option to disable chat functionality in their account settings at any time.', parentalRights: 'Parents have the right to:', right1: 'Review their child\'s personal information', right2: 'Request deletion of their child\'s data', right3: 'Refuse further collection or use of their child\'s information', contactUs: 'To exercise these rights or if you believe your child has provided us with personal information, please contact us immediately at contact@zodiac-chess.com' },
    howWeUse: { title: 'How We Use Your Information', item1: 'Provide and improve our game services', item2: 'Match you with appropriate opponents based on skill level', item3: 'Track your progress, statistics, and achievements', item4: 'Process payments for premium memberships and cosmetic items', item5: 'Send important service announcements and updates', item6: 'Analyze gameplay data to improve game balance and features' },
    thirdParty: { title: 'Third-Party Services', firebase: { title: 'Firebase (Google)', description: 'We use Firebase for authentication, database storage, and multiplayer functionality. Firebase may collect certain data as described in their privacy policy.' }, stripe: { title: 'Stripe', description: 'We use Stripe to process payments for premium memberships and in-app purchases. Stripe handles all payment card information - we never see or store your full payment details.' }, netlify: { title: 'Netlify', description: 'Our website is hosted on Netlify, which may collect standard web hosting data such as IP addresses and access logs.' }, adsense: { title: 'Google AdSense (Future)', description: 'We may display advertisements through Google AdSense. These ads may use cookies for personalization. For child-directed content, we will only show non-personalized ads in compliance with COPPA.' }, viewPolicy: 'View their Privacy Policy' },
    cookies: { title: 'Cookies and Local Storage', description: 'We use browser local storage (similar to cookies) to enhance your experience:', item1: 'Language Preference: Remember your selected language', item2: 'Account Session: Keep you logged in (works with Firebase)', item3: 'Game Settings: Remember your UI preferences and sandbox setups', item4: 'Advertising Cookies: If you consent, third-party ad services may use cookies for ad personalization' },
    security: { title: 'Data Security', p1: 'We implement appropriate security measures to protect your information:', item1: 'Password Encryption: All passwords are encrypted using industry-standard methods', item2: 'Secure Connections: HTTPS encryption for all data transmission', item3: 'Firebase Security Rules: Strict database access controls', p2: 'However, no method of transmission over the internet is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.' },
    retention: { title: 'Data Retention', p1: 'We retain your data as follows:', item1: 'Active Accounts: Data is retained while your account is active', item2: 'Inactive Accounts: If your account is inactive for 10 years, we may delete your data' },
    rights: { title: 'Your Privacy Rights', description: 'Depending on your location, you may have the following rights:', access: { title: 'Access:', description: 'Request a copy of your personal data' }, correction: { title: 'Correction:', description: 'Request corrections to your data' }, deletion: { title: 'Deletion:', description: 'Request deletion of your account and data' }, portability: { title: 'Data Portability:', description: 'Request your data in a portable format' }, optOut: { title: 'Opt-Out:', description: 'Opt out of marketing communications' }, contact: 'To exercise any of these rights, please contact us at contact@zodiac-chess.com' },
    international: { title: 'International Users', p1: 'Zodiac Chess is operated from New Zealand. If you are accessing our service from outside New Zealand, please be aware that your information may be transferred to, stored, and processed in New Zealand and other countries where our service providers operate.', p2: 'By using our service, you consent to the transfer of your information to countries outside your country of residence, which may have different data protection laws.' },
    changes: { title: 'Changes to This Privacy Policy', description: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. Significant changes will be communicated through email or a prominent notice on our website.' },
    contact: { title: 'Contact Us', description: 'If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:', email: 'Email:', company: 'Company:' }
,
    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Términos de Servicio',
    lastUpdated: 'Última actualización',
    back: 'Volver',
    viewPrivacyPolicy: 'Ver Política de Privacidad',
    acknowledgment: 'Al usar Zodiac Chess, reconoces que has leído, comprendido y aceptas estar sujeto a estos Términos de Servicio.',
    acceptance: {
      title: '1. Aceptación de los Términos',
      p1: 'Al acceder y usar Zodiac Chess (el "Servicio"), aceptas y te comprometes a cumplir con estos Términos de Servicio. Si no estás de acuerdo con estos términos, por favor no uses el Servicio.',
      p2: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado del Servicio después de los cambios constituye la aceptación de los términos modificados.',
    },
    description: {
      title: '2. Descripción del Servicio',
      p1: 'Zodiac Chess es un juego de mesa estratégico en línea con piezas de animales únicas con habilidades especiales. El Servicio incluye:',
      feature1: 'Juego para un jugador contra oponentes de IA',
      feature2: 'Emparejamiento multijugador y juego competitivo',
      feature3: 'Tutoriales interactivos y recursos de aprendizaje',
      feature4: 'Creación de cuenta y seguimiento del progreso',
      feature5: 'Funciones de suscripción premium opcionales',
      feature6: 'Opciones de personalización cosmética',
    },
    accounts: {
      title: '3. Cuentas de Usuario',
      eligibility: {
        title: '3.1 Elegibilidad',
        p1: 'Debes tener al menos 13 años para crear una cuenta. Los usuarios menores de 13 años pueden usar el modo de juego como invitado con supervisión parental, pero no pueden crear cuentas.',
      },
      responsibilities: {
        title: '3.2 Seguridad de la Cuenta',
        p1: 'Eres responsable de:',
        item1: 'Mantener la confidencialidad de tu contraseña',
        item2: 'Todas las actividades que ocurran bajo tu cuenta',
        item3: 'Notificarnos inmediatamente de cualquier uso no autorizado',
        p2: 'No somos responsables de ninguna pérdida o daño derivado del acceso no autorizado a la cuenta.',
      },
      prohibited: {
        title: '3.3 Actividades Prohibidas',
        p1: 'NO puedes:',
        item1: 'Compartir tu cuenta con otros',
        item2: 'Usar múltiples cuentas para manipular clasificaciones',
        item3: 'Usar bots, scripts o herramientas automatizadas para jugar',
        item4: 'Acosar, abusar o amenazar a otros jugadores',
        item5: 'Explotar errores o fallos para obtener ventajas injustas',
        item6: 'Realizar ingeniería inversa o intentar acceder a nuestro código fuente',
        p2: 'La violación de estas reglas puede resultar en la suspensión de la cuenta o prohibición permanente.',
      },
    },
    premium: {
      title: '4. Suscripciones Premium',
      billing: {
        title: '4.1 Facturación',
        p1: 'Las suscripciones premium se procesan a través de Stripe. Al comprar una suscripción premium, nos autorizas a cargar tu método de pago de forma recurrente hasta que canceles.',
        p2: 'Las tarifas de suscripción son:',
        item1: 'Plan Mensual: Cargo mensual en el aniversario de tu fecha de compra',
        item2: 'Plan Anual: Cargo anual en el aniversario de tu fecha de compra',
        p3: 'Los precios están sujetos a cambios con 30 días de aviso a los suscriptores activos.',
      },
      cancellation: {
        title: '4.2 Cancelación',
        p1: 'Puedes cancelar tu suscripción en cualquier momento a través de la configuración de tu cuenta o contactando al soporte. La cancelación entra en vigor al final de tu período de facturación actual.',
        p2: 'Conservarás las funciones premium hasta el final de tu período pagado, incluso después de la cancelación.',
      },
      refunds: {
        title: '4.3 Reembolsos',
        p1: 'Suscripciones mensuales: No hay reembolsos por meses parciales. Cancela en cualquier momento para detener cargos futuros.',
        p2: 'Suscripciones anuales: Reembolso completo si se solicita dentro de los 7 días posteriores a la compra. Después de 7 días, los reembolsos quedan a nuestra discreción.',
        p3: 'Compras cosméticas: Generalmente no reembolsables. Contacta al soporte para circunstancias excepcionales.',
      },
    },
    acceptable: {
      title: '5. Política de Uso Aceptable',
      p1: 'Aceptas usar Zodiac Chess de manera respetuosa y legal. La conducta prohibida incluye:',
      item1: 'Hacer trampa, hackear o explotar mecánicas del juego',
      item2: 'Acoso, discurso de odio o lenguaje discriminatorio',
      item3: 'Spam, publicidad o solicitudes',
      item4: 'Compartir contenido inapropiado (si el chat o el contenido generado por usuarios está habilitado)',
      item5: 'Hacerse pasar por otros usuarios o miembros del personal',
      item6: 'Intentar interrumpir o dañar el Servicio',
      p2: 'Nos reservamos el derecho de investigar violaciones y tomar las medidas apropiadas, incluyendo la terminación de la cuenta y el reporte a las autoridades si es necesario.',
    },
    intellectual: {
      title: '6. Derechos de Propiedad Intelectual',
      ownership: {
        title: '6.1 Nuestro Contenido',
        p1: 'Todo el contenido del juego, incluyendo pero no limitado a mecánicas del juego, ilustraciones, animaciones, efectos de sonido, código y diseño, son propiedad de Animal Chess Limited o nuestros licenciantes.',
        p2: 'Se te otorga una licencia limitada, no exclusiva e intransferible para usar el Servicio solo con fines de entretenimiento personal.',
      },
      userContent: {
        title: '6.2 Contenido del Usuario',
        p1: 'Al enviar contenido (como mensajes de chat, nombres de usuario o información de perfil), nos otorgas una licencia mundial y libre de regalías para usar, mostrar y distribuir ese contenido en relación con el Servicio.',
        p2: 'Declaras que posees o tienes los derechos necesarios sobre cualquier contenido que envíes.',
      },
    },
    disclaimers: {
      title: '7. Descargos de Responsabilidad y Limitaciones de Responsabilidad',
      p1: 'EL SERVICIO SE PROPORCIONA "TAL CUAL" SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPRESAS O IMPLÍCITAS.',
      p2: 'No garantizamos que:',
      item1: 'El Servicio será ininterrumpido o libre de errores',
      item2: 'Los defectos serán corregidos',
      item3: 'El Servicio esté libre de virus o componentes dañinos',
      item4: 'Los resultados del uso del Servicio cumplirán tus expectativas',
      p3: 'EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, NO SOMOS RESPONSABLES DE:',
      item5: 'Cualquier daño indirecto, incidental o consecuente',
      item6: 'Pérdida de ganancias, datos o buena voluntad',
      item7: 'Interrupciones del servicio o pérdida de datos',
      item8: 'Daños que excedan la cantidad que nos pagaste en los últimos 12 meses',
    },
    privacy: {
      title: '8. Privacidad',
      p1: 'Tu uso del Servicio también se rige por nuestra Política de Privacidad, que explica cómo recopilamos, usamos y protegemos tu información personal.',
      p2: 'Al usar el Servicio, consientes nuestras prácticas de datos como se describe en la Política de Privacidad.',
    },
    changes: {
      title: '9. Cambios en los Términos',
      p1: 'Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento. Notificaremos a los usuarios sobre cambios importantes mediante:',
      item1: 'Notificación por correo electrónico a usuarios registrados',
      item2: 'Aviso destacado en el sitio web',
      item3: 'Fecha actualizada de "Última actualización" en la parte superior de esta página',
      p2: 'Tu uso continuado del Servicio después de los cambios constituye la aceptación de los términos modificados.',
    },
    governing: {
      title: '10. Ley Aplicable',
      p1: 'Estos Términos de Servicio se rigen por las leyes de Nueva Zelanda, sin tener en cuenta los principios de conflicto de leyes.',
      p2: 'Cualquier disputa que surja de estos términos o tu uso del Servicio se resolverá en los tribunales de Nueva Zelanda.',
    },
    contact: {
      title: '11. Información de Contacto',
      p1: 'Para preguntas, inquietudes o soporte relacionado con estos Términos de Servicio:',
      email: 'Correo electrónico:',
      company: 'Empresa:',
      address: 'Dirección:',
    },
    severability: {
      title: '12. Divisibilidad',
      p1: 'Si alguna disposición de estos términos se considera inaplicable o inválida, esa disposición se limitará o eliminará en la medida mínima necesaria, y las disposiciones restantes permanecerán en pleno vigor y efecto.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Política de Cookies',
    lastUpdated: 'Última actualización',
    browserInstructions: {
      chrome: 'Configuración → Privacidad y seguridad → Cookies',
      firefox: 'Configuración → Privacidad y seguridad → Cookies y datos del sitio',
      safari: 'Preferencias → Privacidad → Cookies y datos de sitios web',
      edge: 'Configuración → Privacidad, búsqueda y servicios → Cookies',
    },
    cookieTable: {
      name: 'Nombre de la cookie',
      purpose: 'Propósito',
      duration: 'Duración',
      type: 'Tipo',
    },
    relatedPolicies: {
      title: 'Políticas relacionadas',
      description: 'Para más información sobre cómo manejamos tus datos, por favor consulta:',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
    },

    introduction: {
      title: 'Introducción',
      p1: 'Esta Política de Cookies explica cómo Zodiac Chess ("nosotros," "nuestro") utiliza cookies y tecnologías similares cuando visitas nuestro sitio web.',
      p2: 'Al usar nuestro sitio web, consientes nuestro uso de cookies de acuerdo con esta política. Si no estás de acuerdo, por favor desactiva las cookies en la configuración de tu navegador o no uses nuestro sitio web.',
    },
    what: {
      title: '¿Qué son las Cookies?',
      p1: 'Las cookies son pequeños archivos de texto que se colocan en tu dispositivo (computadora, smartphone, tablet) cuando visitas un sitio web. Se utilizan ampliamente para hacer que los sitios web funcionen de manera eficiente y proporcionar información a los propietarios del sitio.',
      p2: 'Las cookies sirven para varios propósitos, incluyendo recordar tus preferencias, analizar el uso del sitio y habilitar ciertas funciones.',
    },
    types: {
      title: 'Tipos de Cookies que Usamos',
      necessary: {
        title: '1. Cookies Necesarias',
        description: 'Estas cookies son esenciales para que el sitio web funcione correctamente. Sin estas cookies, los servicios que has solicitado no pueden ser proporcionados.',
        examples: 'Ejemplos:',
        item1: 'Cookies de autenticación - Te mantienen conectado a tu cuenta',
        item2: 'Cookies de seguridad - Protegen contra actividad fraudulenta',
        item3: 'Cookies de sesión - Mantienen el estado de tu juego durante una sesión',
        item4: 'Preferencias de consentimiento de cookies - Recuerdan tus elecciones de cookies',
      },
      analytics: {
        title: '2. Cookies de Análisis',
        description: 'Estas cookies nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web recopilando información anónima sobre visitas a páginas, tiempo dedicado y funciones utilizadas.',
        provider: 'Proveedor: Firebase Analytics (Google)',
        purpose: 'Propósito:',
        item1: 'Medir el tráfico del sitio web y la participación del usuario',
        item2: 'Identificar funciones y páginas populares',
        item3: 'Entender la demografía del usuario (rango de edad, ubicación general)',
        item4: 'Mejorar el rendimiento del sitio web y la experiencia del usuario',
      },
      advertising: {
        title: '3. Cookies Publicitarias',
        description: 'Estas cookies se utilizan para mostrar anuncios que son relevantes para ti. También limitan el número de veces que ves un anuncio y ayudan a medir la efectividad de las campañas publicitarias.',
        provider: 'Proveedor: Google AdSense',
        purpose: 'Propósito:',
        item1: 'Mostrar anuncios personalizados basados en tus intereses',
        item2: 'Medir el rendimiento de los anuncios y la participación',
        item3: 'Evitar mostrar el mismo anuncio demasiadas veces',
        note: 'Nota: Los suscriptores premium nunca ven anuncios, independientemente de la configuración de cookies.',
      },
    },
    firstThird: {
      title: 'Cookies Propias vs Cookies de Terceros',
      firstParty: {
        title: 'Cookies Propias',
        description: 'Estas son cookies establecidas directamente por Zodiac Chess. Las usamos para la funcionalidad esencial del sitio, autenticación y recordar tus preferencias.',
      },
      thirdParty: {
        title: 'Cookies de Terceros',
        description: 'Estas son cookies establecidas por servicios externos que utilizamos, como Google Analytics y Google AdSense. Las cookies de terceros están sujetas a las políticas de privacidad de esos proveedores.',
      },
    },
    specific: {
      title: 'Cookies Específicas que Usamos',
      tableHeader: 'A continuación se muestra una lista detallada de las cookies utilizadas en nuestro sitio web:',
    },
    control: {
      title: 'Cómo Controlar las Cookies',
      consent: {
        title: '1. Banner de Consentimiento de Cookies',
        description: 'Cuando visites nuestro sitio web por primera vez, verás un banner de consentimiento de cookies. Puedes:',
        item1: 'Aceptar todas - Permitir todas las cookies (necesarias, de análisis y publicitarias)',
        item2: 'Rechazar opcionales - Solo permitir cookies necesarias (sin análisis ni anuncios)',
        item3: 'Personalizar - Elegir exactamente qué tipos de cookies quieres permitir',
      },
      browser: {
        title: '2. Configuración del Navegador',
        description: 'La mayoría de los navegadores web te permiten controlar las cookies a través de su configuración. Puedes:',
        item1: 'Bloquear todas las cookies',
        item2: 'Aceptar solo cookies propias',
        item3: 'Eliminar cookies después de cada sesión de navegación',
        item4: 'Ver y eliminar cookies individuales',
        links: 'Aquí hay enlaces para la gestión de cookies en navegadores populares:',
      },
      optOut: {
        title: '3. Herramientas de Exclusión',
        description: 'Para las cookies publicitarias específicamente, puedes optar por no recibir anuncios personalizados:',
        googleLink: 'Configuración de Anuncios de Google',
        googleDesc: ' - Gestiona los anuncios personalizados de Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Excluirse de la publicidad basada en intereses',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Herramienta de exclusión específica para la UE',
      },
    },
    impact: {
      title: 'Impacto de Desactivar las Cookies',
      p1: 'Si desactivas o rechazas las cookies, ten en cuenta que:',
      item1: 'Algunas partes del sitio web pueden no funcionar correctamente',
      item2: 'Es posible que necesites volver a ingresar tus preferencias en cada visita',
      item3: 'Puede que se cierre tu sesión de tu cuenta',
      item4: 'Las cookies necesarias son requeridas para que el sitio funcione - desactivarlas te impedirá usar las funciones principales',
    },
    updates: {
      title: 'Actualizaciones de Esta Política de Cookies',
      p1: 'Podemos actualizar esta Política de Cookies de vez en cuando para reflejar cambios en nuestras prácticas o por razones legales, regulatorias u operativas.',
      p2: 'Te notificaremos de cambios significativos actualizando la fecha de "Última actualización" en la parte superior de esta página. Por favor revisa esta política periódicamente.',
    },
    contact: {
      title: 'Contáctanos',
      p1: 'Si tienes preguntas sobre nuestro uso de cookies o esta Política de Cookies, por favor contáctanos:',
      email: 'Correo electrónico:',
      company: 'Empresa:',
    },
  },

  // Game
  game: {
    yourTurn: 'Tu Turno',
    opponentTurn: 'Turno del Oponente',
    victory: '¡Victoria!',
    defeat: 'Derrota',
    draw: 'Empate',
    resign: 'Rendirse',
    offerDraw: 'Ofrecer Empate',
  },

  // Game End Popup
  gameEnd: {
    victory: '¡VICTORIA!',
    defeat: '¡DERROTA!',
    draw: '¡EMPATE!',
    wonBy: 'Ganaste por {condition}',
    lostBy: 'Perdiste por {condition}',
    drawBy: 'Empate por {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Regicidio',
      race: 'Victoria de Carrera',
      timeout: 'Tiempo Agotado',
      threefold: 'Triple Repetición',
      noMoves: 'Sin Movimientos Válidos',
      draw: 'Empate',
    },
  },

  // Game Info
  gameInfo: {
    title: 'Info del Juego',
    sandboxMode: 'Modo Sandbox',
    lightTurn: 'Turno del Claro',
    darkTurn: 'Turno del Oscuro',
    yourTurn: 'Tu turno',
    opponentTurn: 'Turno del oponente',
    aiThinking: 'IA pensando...',

    // Selection states
    selecting: 'Seleccionando {piece}',
    observing: 'Observando {piece}',
    selectingZombified: 'Seleccionando enemigo zombificado {piece}',
    selectionLocked: 'Selección bloqueada en {piece}',
    selectionLockedPenguin: 'Pingüino tiene selección bloqueada',

    // Hints
    clickToFaint: 'Haz clic en {piece} para desmayarse',
    clickToRotate: 'Haz clic en {piece} para rotar',
    clickToInk: 'Haz clic en {piece} para tinta',
    zombifiedWarning: '⚠️ ¡Mientras está zombificado, {piece} rota antes de moverse!',

    // Monkey bonus turn
    monkeySwing: 'Mono completó el balanceo, mueve tu Mono para completar el turno bonus',
    monkeyConsume: 'Mono consumió hongo, mueve tu Mono para completar el turno bonus',

    // Virus bonus turn
    virusInfecting: 'Virus está infectando, continúa el turno o haz clic en virus para terminar',

    // Penguin bonus turn
    penguinRotate: 'Pingüino completó deslizamiento - elige la dirección final de rotación',
    penguinCaptureRotate: 'Pingüino completó captura - elige la dirección final de rotación',
    penguinZombified: 'Pingüino zombificado rotó - completa el turno con deslizamiento/captura (la zombificación terminará)',

    // Capture restrictions
    cannotCapture: '{piece} no puede capturar: {targets}',
    cannotInfect: '{piece} no puede infectar: {targets}',
    cannotEntangle: '{piece} no puede enredar: {targets}',
    monkeyBearRoll: '{piece} debe sacar 5-6 para capturar al enemigo {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Oso',
    Crane: 'Grulla',
    Frog: 'Rana',
    Fungi: 'Hongo',
    Goat: 'Cabra',
    Monkey: 'Mono',
    Octopus: 'Pulpo',
    Penguin: 'Pingüino',
    Rhino: 'Rinoceronte',
    Snake: 'Serpiente',
    Tree: 'Árbol',
    Virus: 'Virus',
    Wolf: 'Lobo',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Contexto de Movimiento',
    emptyState: 'Selecciona una habilidad del panel izquierdo para ver información detallada.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'ARENA IA',
    tagline: '¡Elige una IA para combatir o mira a las IAs enfrentarse!',

    // Player labels
    lightPlayer: 'Jugador Claro',
    darkPlayer: 'Jugador Oscuro',
    humanPlayer: 'Jugador Humano',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Centinela',
    aiAlchemist: 'Alquimista',
    aiZenith: 'Cénit',
    aiTrapper: 'Trampero',
    aiHunter: 'Cazador',
    aiWisp: 'Espíritu',
    aiCreature: 'Creature',
    aiWeaver: 'Tejedor',

    // Time Frames
    timeFast: 'Rápido',
    timeStandard: 'Estándar',
    timeDeep: 'Profundo',

    // Thinking time
    thinkingTime: 'Tiempo de Pensamiento',

    // Info box
    matchupLabel: 'Enfrentamiento:',
    statusLabel: 'Estado:',
    statusPaused: 'PAUSADO',
    statusAIThinking: 'IA Pensando...',
    statusInGame: 'En Juego',
    statusReady: 'Listo',
    matchupLocal2P: 'Local 2J',
    matchupPlayerVs: 'Jugador vs',
    matchupVsPlayer: 'vs Jugador',

    // Buttons
    startButton: 'Iniciar',
    startRandomButton: 'Iniciar Aleatorio',
    newGameButton: 'Nueva Partida',
    resumeButton: 'Reanudar',
    pauseButton: 'Pausar',
    pauseQueuedButton: 'Pausar (en cola...)',
    viewKingsButton: 'Ver Reyes',
    hideKingsButton: 'Ocultar Reyes',
    viewKingsQueuedButton: 'Ver Reyes (en cola...)',
    hideKingsQueuedButton: 'Ocultar Reyes (en cola...)',
    homeButton: 'Inicio',
    toggleKingVisibility: 'Alternar visibilidad del rey',

    // Warning modal
    invalidPlacement: 'Colocación Inválida',
    okButton: 'OK',
    warningLightTurn: '¡Es el turno del jugador Claro para colocar una pieza!',
    warningDarkTurn: '¡Es el turno del jugador Oscuro para colocar una pieza!',
    warningLightRow: '¡Las piezas Claras deben colocarse en la fila 0 (tu fila base)!',
    warningDarkRow: '¡Las piezas Oscuras deben colocarse en la fila 7 (tu fila base)!',
    warningOccupied: '¡Esta casilla ya está ocupada! Elige una casilla vacía.',
    warningKingRequired: '¡Debes colocar tu rey ({kingType}) antes de colocar tu 5ª pieza!',

    // Piece selection
    dragPieces: 'Arrastra piezas al tablero',
    lightPieces: 'Piezas Claras',
    darkPieces: 'Piezas Oscuras',

    // Mobile
    selectYourKing: 'Selecciona Tu Rey',
    selectPieceToPlace: 'Selecciona Pieza para Colocar',
    moveHistory: 'Historial de Movimientos',
    historyButton: 'Historial',
    backButton: 'Atrás',
    lightTurn: 'Turno del Claro',
    darkTurn: 'Turno del Oscuro',
  },

  // Donation
  donation: {
    title: 'Apoya Zodiac Chess',
    supportDevelopment: 'Apoya el Desarrollo',
    story1: '¡Hola! ¡Tu apoyo me ayuda a seguir mejorando este juego único! Añadir nuevas funciones, mantener servidores y mantener Zodiac Chess gratis para la comunidad.',
    story2: 'Incluso una pequeña donación hace una gran diferencia y mantiene vivo este proyecto. ¡Gracias por ser parte del viaje de Zodiac Chess! :)',
    selectAmount: 'Elige Cantidad',
    customAmount: 'O ingresa cantidad personalizada:',
    total: 'Total:',
    donateButton: 'Donar Ahora',
    processing: 'Procesando...',
    disclaimer: 'Las donaciones apoyan el desarrollo y los costos del servidor. ¡Gracias por tu generosidad!',
    invalidAmount: 'Por favor ingresa una cantidad válida mayor a $0',
    error: 'Hubo un error procesando tu donación. Por favor intenta de nuevo.',
  },

  // Upgrade Modal
  upgrade: {
    title: 'Mejorar a Premium',
    accountRequired: 'Necesitas crear una cuenta permanente antes de mejorar a premium.',
    createAccountPrompt: '¡Crea una cuenta para guardar tu progreso y desbloquear funciones premium!',
    subtitle: '¡Desbloquea funciones poderosas para mejorar tu experiencia en Zodiac Chess!',
    features: {
      history: 'Historial de Cuenta',
      historyItem1: 'Almacena y recupera todas tus partidas anteriores',
      historyItem2: 'Reproduce tus partidas antiguas desde cualquier punto para evaluar estrategia',
      historyItem3: 'Usa análisis profundo para analizar posiciones del tablero y oportunidades de movimientos brillantes',
      analytics: 'Estadísticas',
      analyticsItem1: 'Obtén acceso a estadísticas de juego',
      analyticsItem2: 'Analiza la selección de piezas y rey de usuarios a través de toneladas de métricas',
      analyticsItem3: '¡Descubre qué metas son populares y qué está funcionando!',
      course: 'Curso',
      courseItem1: 'Obtén acceso a cursos actualizados para desarrollar tu habilidad',
      courseItem2: 'Aprende metas y conceptos de los profesionales',
      courseItem3: 'Obtén consejos sobre tu propio juego para analizar tus debilidades',
    },
    createAccount: 'Crear Cuenta',
    upgradeNow: 'Mejorar Ahora',
    cancel: 'Cancelar',
  },

  // Premium Modal
  premium: {
    title: 'Función Premium',
    accessDenied: '¡Lo siento, no tienes una cuenta premium, aún no tienes acceso a estas funciones!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: '¡Ups! Algo Salió Mal',
    errorMessage: 'Encontramos un problema procesando tu pago. No te preocupes, no se ha cobrado nada.',
    whatHappened: '¿Qué pasó?',
    notCompleted: 'Tu pago no se completó. Esto podría deberse a:',
    reasons: {
      cancelled: 'El pago fue cancelado',
      declined: 'La tarjeta fue rechazada',
      connection: 'Problema de conexión durante el pago',
      expired: 'La sesión expiró',
    },
    whatToDo: '¿Qué puedes hacer?',
    actions: {
      tryDifferentCard: 'Intenta con una tarjeta diferente',
      tryDifferentCardDesc: 'Usa otro método de pago',
      retryPayment: 'Reintentar el pago',
      retryPaymentDesc: 'A veces un simple reintento funciona',
      checkBank: 'Consulta con tu banco',
      checkBankDesc: 'Asegúrate de que tu tarjeta tenga fondos suficientes',
    },
    tryAgain: 'Intentar Mejorar de Nuevo',
    returnHome: 'Volver a la Página Principal',
    contactSupport: '¿Necesitas ayuda? Contacta soporte en support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: '¿De qué se trata?',
    gameSetup: 'Configuración del Juego',
    basicRules: 'Reglas Básicas',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
